/**
 * Interfaz para los parámetros de respuesta de Azul Payment Gateway
 * Estos parámetros son enviados cuando Azul redirige de vuelta a las URLs de callback
 * Basado en la documentación oficial de Azul Servicios Digitales Popular
 */
export interface AzulPaymentResponse {
  // Campos principales de respuesta
  OrderNumber?: string; // Número de orden enviado en la solicitud inicial (HASH: Sí)
  Amount?: string; // Monto original de la transacción (HASH: Sí)
  ITBIS?: string; // ITBIS original de la transacción (HASH: No)
  AuthorizationCode?: string; // Código de autorización si la transacción fue aprobada (HASH: Sí)
  DateTime?: string; // Fecha de la transacción (HASH: Sí)
  ResponseCode?: string; // Código de respuesta de la transacción (HASH: Sí)
  IsoCode?: string; // Código ISO de respuesta de la transacción (HASH: Sí)
  ResponseMessage?: string; // Mensaje de respuesta de la transacción (HASH: Sí)
  ErrorDescription?: string; // Descripción del error de la transacción (HASH: Sí)
  
  // Campos adicionales
  RRN?: string; // Número de referencia (Reference Referral Number) (HASH: Sí)
  DataVaultToken?: string; // Token generado para la tarjeta si SaveToDataVault fue 1 (HASH: No)
  DataVaultExpiration?: string; // Expiración del token en formato AAAAMM (HASH: No)
  DataVaultBrand?: string; // Marca de la tarjeta usada (ej: Visa, Mastercard) (HASH: No)
  AzulOrderId?: string; // Número de orden del procesador AZUL (HASH: No)
  Datavault?: string; // Campo de datavault (HASH: No)
  Discounted?: string; // Indica si la transacción aplicó descuento por Bines. 0 = sin descuento, 1 = con descuento (HASH: No)
  
  // Campos adicionales que pueden venir
  [key: string]: string | undefined; // Para capturar cualquier otro parámetro adicional
}

/**
 * Función helper para extraer parámetros de respuesta de Azul
 * Maneja tanto parámetros POST como GET (query parameters)
 */
export const getAzulResponseParams = (): AzulPaymentResponse => {
  const params: AzulPaymentResponse = {};

  const urlParams = new URLSearchParams(window.location.search);
  const queryString = urlParams.toString();
  const paramCount = queryString ? queryString.split('&').filter(p => p.length > 0).length : 0;

  if (paramCount > 0) {
    urlParams.forEach((value, key) => {
      params[key] = value;
    });
  }

  if (window.location.hash) {
    const hashParams = new URLSearchParams(window.location.hash.substring(1));
    hashParams.forEach((value, key) => {
      if (!params[key]) {
        params[key] = value;
      }
    });
  }

  return params;
};

